"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_final_form_1 = require("react-final-form");
const components_1 = require("components");
const config_1 = require("config");
const hooks_1 = require("hooks");
const utils_1 = require("utils");
function IntroFormEDS({ submitCallback, }) {
    const query = (0, hooks_1.useQuery)();
    const hasLocId = query.get('locationId');
    const formValidate = (values) => {
        if (values) {
            const errors = {};
            if (!values.firstName) {
                errors.firstName = 'First Name Required';
            }
            if (!values.lastName) {
                errors.lastName = 'Last Name Required';
            }
            if (!values.email) {
                errors.email = 'Email Required';
            }
            if (!hasLocId && !values.specialty) {
                errors.specialty = 'Specialty Required';
            }
            if (Object.keys(errors).length) {
                return errors;
            }
            else {
                return undefined;
            }
        }
    };
    const formSubmit = (values) => {
        // Submitted Values
        if (values) {
            //do something useful
            const isFormValid = formValidate(values);
            // Is form valid
            if (isFormValid === undefined) {
                // Form is valid
                if (submitCallback) {
                    submitCallback(values);
                }
                return undefined;
            }
            else {
                // Form IS NOT VALID
                return isFormValid;
            }
        }
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "forms-container", children: (0, jsx_runtime_1.jsx)(react_final_form_1.Form, { initialValues: {
                ...(hasLocId ? { locationId: hasLocId } : {}),
            }, onSubmit: formSubmit, render: ({ handleSubmit, values, submitting, hasValidationErrors }) => {
                return ((0, jsx_runtime_1.jsxs)("form", { onSubmit: handleSubmit, noValidate: true, children: [(0, jsx_runtime_1.jsxs)("div", { className: "card border-rad-10 border-width-1", children: [(0, jsx_runtime_1.jsx)("div", { className: "card-title text-center pad-b-30 border-b-1 mar-b-20", children: (0, jsx_runtime_1.jsx)(components_1.H2, { variant: "headline-small", children: "Get Started" }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-wrap-sm col-gap-20  space-between", children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "firstName", component: components_1.InputText, placeholder: "First Name", label: "First Name", required: true, validate: utils_1.validateRequiredField }), (0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "lastName", component: components_1.InputText, label: "Last Name", placeholder: "Last Name", required: true, validate: utils_1.validateRequiredField })] }), (0, jsx_runtime_1.jsxs)("div", { className: "flex-wrap-sm col-gap-20 space-between", children: [(0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "email", component: components_1.InputText, label: "Email Address", placeholder: "Email Address", type: "email", required: true, validate: (0, utils_1.composeValidators)(utils_1.validateRequiredField, utils_1.validateEmail) }), !hasLocId ? ((0, jsx_runtime_1.jsx)(components_1.InputSelectNative, { name: "specialty", label: 'Specialty', options: config_1.DOCTOR_SPECIALTIES, placeholder: "Select Your Doctor's Specialty", required: true })) : ((0, jsx_runtime_1.jsx)(react_final_form_1.Field, { name: "locationId", component: 'input', type: "hidden" }))] }), (0, jsx_runtime_1.jsx)(components_1.FieldTermsAgreements, {})] }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)(components_1.Button, { type: "submit", disabled: !values.agreed || submitting || hasValidationErrors, submitting: submitting, className: `w100 button-warn ${!values.agreed ? `warn-disabled` : ``}`, children: "AGREE AND GET STARTED" }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {})] }));
            } }) }));
}
exports.default = IntroFormEDS;
